module.exports = __webpack_public_path__ + "static/media/maxDailyLogin_270_365.584e0d7e.png";